import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Services from "@/pages/Services";
import Quotes from "@/pages/Quotes";
import Jobs from "@/pages/Jobs";
import Schedule from "@/pages/Schedule";
import Invoices from "@/pages/Invoices";
import Team from "@/pages/Team";
import PayInvoice from "@/pages/PayInvoice";
import ApproveQuote from "@/pages/ApproveQuote";
import TimeClock from "@/pages/TimeClock";
import TimeHub from "@/pages/TimeHub";
import JobDetail from "@/pages/JobDetail";
import QuoteDetail from "@/pages/QuoteDetail";
import ClientDetail from "@/pages/ClientDetail";
import Intake from "@/pages/Intake";
import Pipeline from "@/pages/Pipeline";
import Reports from "@/pages/Reports";
import MyDay from "@/pages/MyDay";
import Settings from "@/pages/Settings";
import Portal from "@/pages/Portal";
import PaymentSuccess from "@/pages/PaymentSuccess";

function Protected({ children, adminOnly }) {
  const { user, checked } = useAuth();
  if (!checked) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function LoginRoute() {
  const { user, checked } = useAuth();
  if (!checked) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/pay/:id" element={<PayInvoice />} />
            <Route path="/approve/:id" element={<ApproveQuote />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/portal" element={<Portal />} />
            <Route path="/portal/:token" element={<Portal />} />

            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/intake" element={<Protected adminOnly><Intake /></Protected>} />
            <Route path="/pipeline" element={<Protected adminOnly><Pipeline /></Protected>} />
            <Route path="/reports" element={<Protected adminOnly><Reports /></Protected>} />
            <Route path="/my-day" element={<Protected><MyDay /></Protected>} />
            <Route path="/settings" element={<Protected adminOnly><Settings /></Protected>} />
            <Route path="/time" element={<Protected><TimeClock /></Protected>} />
            <Route path="/schedule" element={<Protected><Schedule /></Protected>} />
            <Route path="/jobs" element={<Protected><Jobs /></Protected>} />
            <Route path="/jobs/:id" element={<Protected><JobDetail /></Protected>} />
            <Route path="/clients" element={<Protected adminOnly><Clients /></Protected>} />
            <Route path="/clients/:id" element={<Protected adminOnly><ClientDetail /></Protected>} />
            <Route path="/quotes" element={<Protected adminOnly><Quotes /></Protected>} />
            <Route path="/quotes/:id" element={<Protected adminOnly><QuoteDetail /></Protected>} />
            <Route path="/invoices" element={<Protected adminOnly><Invoices /></Protected>} />
            <Route path="/services" element={<Protected adminOnly><Services /></Protected>} />
            <Route path="/time-hub" element={<Protected adminOnly><TimeHub /></Protected>} />
            <Route path="/team" element={<Protected adminOnly><Team /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
